import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import form_styles from "../../Form/Form.module.css";
import FieldCustom from "../../Field/FieldCustom";
import styles from "../../../pages/Admin/Admin.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import FieldUpload from "../../Field/FieldUpload";
import modalSuccess from "../../Modal/ModalSuccess";
import {useModal} from "../../../contexts/ModalContext";
import {Link, useNavigate} from "react-router-dom";
import TitleSecondary from "../../Title/TitleSecondary";
import SearchCoach from "../../Search/SearchCoach";
import BtnSave from "../../Button/BtnSave";
import FieldCheckbox from "../../Field/FieldCheckbox";
import TitleMain from "../../Title/TitleMain";
import TextAreaCustom from "../../Field/TextAreaCustom";
import stylesField from "../../Field/Field.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong} from "@fortawesome/free-solid-svg-icons";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import DateService from "../../../services/DateService";
import Routing from "../../../services/routing";

function SeanceCreation({ activite = null, contrat = null, entreprise = null, seance = null }) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const formikRef = React.useRef();
    const [coach, setCoach] = useState(null);
    const [actId, setActId] = useState(null);
    const [showLocation, setShowLocation] = useState(false);
    let title = seance ? "Modifier une séance" : "Créer une séance";
    let navigate = useNavigate();

    const initialValues = {
        lieu_nom: seance?.lieu?.nom || "",
        lieu_adresse: seance?.lieu?.adresse || "",
        lieu_ville: seance?.lieu?.ville || "",
        lieu_code_postal: seance?.lieu?.code_postal || "",
        date: DateService.formatDateForInput(seance?.date) || "",
        periode_inscription_actif: !!(seance && (seance.periode_inscription !== null && seance.periode_inscription > DateService.formatDate("1900-01-01"))),
        periode_inscription: seance && seance.periode_inscription ? DateService.formatDateForInput(seance.periode_inscription): "",
        acces_anticipe_actif: seance ? !!seance.acces_anticipe_actif : false,
        acces_anticipe: seance && seance.acces_anticipe ? DateService.formatDateForInput(seance.acces_anticipe) : "",
        participants_max: seance?.participantsMax || 10,
        // desactiver: seance ? !seance?.actif : false,
        status: seance?.status ?? "",
        status_info: seance?.status_info ?? "",
    };

    const handleSuccess = (children = "Enregistré avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const handleSubmit = async (values, {setSubmitting}) => {
        values.coach = coach ? coach : null;
        values.seance_id = seance && seance.id ? seance.id : null;
        values.acces_anticipe_actif = values.acces_anticipe !== "";

        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/creation`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                navigate(Routing.generate({route: Routing.routes.adminSeanceDirect, params: {seanceId: response.data.id}}));
            } else {
                handleError(response.data.error ?? response.data.message);
            }
        } catch (error) {
            console.error(error);
            handleError(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    const submitCoach = (values) => {
        setCoach(values.email);
    }

    useEffect(() => {
        if (!activite) return;

        if (activite && activite.type && activite.type.id) {
            setActId(activite.type.id);
        }
    }, [activite]);

    useEffect(() => {
        if (!seance) return;
        if (seance && seance.coach) {
            setCoach(seance.coach.email);
        }

        if (seance && seance.type && seance.type.id) {
            setActId(seance.type.id);
        }
        title = seance ? "Modifier une séance" : "Créer une séance";
    }, [seance]);

    return (
        <div className="content">
            { seance?.titre ? <TitleMain text={seance?.titre}/> : <TitleMain text={"Séances"}/> }
        <div style={{margin: '0 0 50px 0'}} className={styles.viewBloc}>
            <TitleSecondary text={title} />

            { actId !== null &&
                <div className={styles.presentationContainer} style={{ marginBottom: "0", width: "100%" }}>
                    <SearchCoach onSubmit={submitCoach} label={"Coach"} act={actId}/>
                    <span style={{ marginTop: "10px", color: "#74a61d", fontSize: "var(--fs-secondary)", fontStyle: "italic" }}>{coach ? <span style={{ color: "var(--clr-success)" }}>{ coach }</span> : <span style={{ color: "var(--clr-danger)" }}>Pas de coach sélectionné</span>}</span>
                </div>
            }

            {Object.keys(initialValues).length > 0 ? (
                <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize innerRef={formikRef}>
                    {({isSubmitting, setFieldValue, values}) => {
                        return (
                            <Form className={styles.form}>
                                <div className={styles.presentationContainer}>

                                    <FieldCheckbox
                                        name="showLocation"
                                        label={"Utiliser l'adresse : " + activite?.lieu?.adresse + ", " + activite?.lieu?.ville + ", " + activite?.lieu?.code_postal}
                                        onChange={() => setShowLocation(prev => !prev)}
                                    />

                                    {!showLocation && (
                                        <div>
                                            <FieldCustom name={"lieu_adresse"} label={"Adresse"} placeholder={"Adresse"}/>

                                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", gap: "16px" }}>
                                                <FieldCustom name={"lieu_nom"} label={"Nom du lieu (ex: Salle de sport, Salle n°14, etc.)"} placeholder={"Salle n°14"} style={{ flex: 2 }}/>
                                                <FieldCustom name={"lieu_ville"} label={"Ville"} placeholder={"Ville"} style={{ flex: 2 }}/>
                                                <FieldCustom name={"lieu_code_postal"} label={"Code postal"} placeholder={"Code postal"} style={{ flex: 1 }}/>
                                            </div>
                                        </div>
                                    )}

                                    <FieldCustom type={"datetime-local"} name={"date"} label={"Date"}/>
                                    <FieldCustom type={"number"} name={"participants_max"} label={"Nombre de participants max"}/>

                                    <div className={stylesField.select}>
                                        <span>Statut</span>
                                        <Field as={"select"} name={"status"}>
                                            <option value={""}>-- Sélectionnez un statut --</option>
                                            <option value={"1"}>Actif</option>
                                            <option value={"2"}>Validé</option>
                                            <option value={"3"}>Annulé</option>
                                        </Field>
                                    </div>

                                    <TextAreaCustom label={"Statut info"} type={"text"} name={"status_info"} placeholder={"Motif d'annulation, etc"}/>

                                    <div style={{marginTop: "16px"}}>
                                        <FieldCheckbox name={"periode_inscription_actif"} label={"Activer une période inscription"}/>
                                    </div>

                                    {values.periode_inscription_actif && (
                                        <>
                                            <FieldCustom type={"datetime-local"} name={"periode_inscription"} label={"Début d'inscription possible"}/>
                                            <FieldCustom type={"datetime-local"} name={"acces_anticipe"} label={"Accès anticipé"}/>
                                        </>
                                )}

                                    {/*
                                       <FieldCheckbox name={"desactiver"} label={"supprimer cette séance"}/>
                                    */}
                                </div>

                                <div className={"barre_btn"}>
                                    <button type={"button"} onClick={() => {
                                        navigate(-1)
                                    }} className={"btn btn_danger"}><AnnulerIcone/>Annuler
                                    </button>
                                    <BtnSave isSubmitting={isSubmitting}/>
                                </div>
                            </Form>
                        )
                    }
                    }
                </Formik>
            ) : (<p>Chargement...</p>)}
        </div>
        </div>);
}

export default SeanceCreation;